import React, { Component } from 'react'
import Select from 'react-select-plus'
import Icon from 'svg-inline-react'
import * as CONSTANTS from 'app/modules/rules/constants'

const emptyCustomValue = { label: 'Custom', value:{ min: null, max: null }}

class MoneyRaisedFilter extends Component {

  constructor(props) {
    super(props)

    const initialValue = props.activeFilter.value

    this.state = {
      selectedValue: initialValue,
      isCustom: !this.hasMatchedGroup(initialValue)
    }
  }

  hasMatchedGroup(isMatchedGroup) {
    const matched = _.find(CONSTANTS.MONEY_RAISED_GROUPS, (group) => {
      return _.isEqual(group, isMatchedGroup) 
    })

    return !!matched ? { value: matched, label: `$${matched.min} - $${matched.max} million` } : null
  }

  updateMin = (event) => {
    const currentValue = event.target.value
    this.setState((prevState) => {
      return { selectedValue: Object.assign(prevState.selectedValue, { min: currentValue }) }
    }, this.updateCondition)
  }

  updateMax = (event) => {
    const currentValue = event.target.value
    this.setState((prevState) => {
      return { selectedValue: Object.assign(prevState.selectedValue, { max: currentValue }) }
    }, this.updateCondition)
  }

  updateCondition = () => {
    const updatedCondition = {
      operator: CONSTANTS.MONEY_RAISED_FILTER_OPERATORS.BTW, 
      value: this.state.selectedValue
    }

    this.isValid() && this.props.onUpdateCondition(updatedCondition)
  }

  isValid() {
    return !!this.state.selectedValue.min && !!this.state.selectedValue.max
  }

  onSelect = (group) => {
    if (group.value === 'CUSTOM') {
      return this.setState({
        selectedValue: emptyCustomValue, 
        isCustom: true
      })
    }

    return this.setState({
      selectedValue: group.value,
      isCustom: false
    }, this.updateCondition)
  }

  renderMoneyDropdown() {
    const selectOptions = {
      multi: false,
      autoFocus: true,
      value: this.hasMatchedGroup(this.state.selectedValue) || emptyCustomValue,
      onChange: this.onSelect,
      clearable: false,
      options: [
        ...CONSTANTS.MONEY_RAISED_GROUPS.map((group) => {
          return { value: group, label: `$${group.min} - $${group.max} million` } 
        }), { label: 'Custom', value: 'CUSTOM' }
      ],
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderCustomInput() {
    if (!this.state.isCustom) return

    return (
      <div className="rule-filter-custom-input drift-form">
        <input type="number" placeholder="$0" onChange={this.updateMin} defaultValue={this.state.selectedValue.min} />
        <span>to</span>
        <input type="number" placeholder="$0" onChange={this.updateMax} defaultValue={this.state.selectedValue.max} />
        <span>million</span>
      </div>
    )
  }

  render() {
    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-options">
          {this.renderMoneyDropdown()}
          {this.renderCustomInput()}
        </div>
      </div>
    )
  }
}

export default MoneyRaisedFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/MoneyRaisedFilter.js